import Vue from 'vue'
import { debounce, throttle } from 'lodash'
import EventBus from '../_event-bus'
const DEBOUNCE_THRESHOLD = 3000

Vue.component('vue-cart-input', {
  template: '#vue-cart-input-template',
  props: ['count', 'id', 'disabled'],
  data() {
    return {
      itemCount: null,
      isDisabled: false,
      timeOut: null,
    }
  },
  methods: {
    addListeners() {
      if (this.$refs.btnUp) this.$refs.btnUp.addEventListener('click', this.increaseItemCount)

      if (this.$refs.btnDown) this.$refs.btnDown.addEventListener('click', this.decreaseItemCount)
    },
    increaseItemCount() {
      this.itemCount = parseInt(this.itemCount) + 1
      if (this.timeOut) window.clearTimeout(this.timeOut)
      this.timeOut = window.setTimeout(this.emitSetItemCounEvent, 1000)
    },
    emitSetItemCounEvent() {
      EventBus.$emit('set-item-count', { count: this.itemCount, id: this.$props.id })
    },
    emitRemoveFromCartEvent() {
      EventBus.$emit('remove-from-cart', { id: this.$props.id })
    },
    decreaseItemCount() {
      if (parseInt(this.itemCount) - 1 < 0) return
      else this.itemCount = parseInt(this.itemCount - 1)
      if (this.itemCount > 0) {
        if (this.timeOut) window.clearTimeout(this.timeOut)
        this.timeOut = window.setTimeout(this.emitSetItemCounEvent, 1000)
      } else if (this.itemCount === 0) {
        if (this.timeOut) window.clearTimeout(this.timeOut)
        this.timeOut = window.setTimeout(this.emitRemoveFromCartEvent, 1000)
      }
    },
    handleChange(event) {
      event.preventDefault()
      if (event.target.value === '0') {
        EventBus.$emit('remove-from-cart', { id: this.$props.id })
      } else {
        this.itemCount = event.target.value
        EventBus.$emit('set-item-count', { count: this.itemCount, id: this.$props.id })
      }
    },
  },
  mounted() {
    this.addListeners()
    this.itemCount = this.$props.count
    this.isDisabled = this.$props.disabled
  },
})
